export class RoutePropertyChanged {

    public routeId: number;
    public result: boolean;
    public previousPhaseCreated: boolean;
    public previousPhaseId: number;
    public actualPhaseId: number;
    public actualPhaseDeleted: boolean;
    public phasesTouched: boolean;

    public uuidExwork: string;


    static setRouteId(data: RoutePropertyChanged, routeId: number, uuidExwork: string): RoutePropertyChanged {
        if (data != null){
            data.routeId = routeId;
            data.uuidExwork = uuidExwork;
        }
        return data;
    }
}